<template>
  <div class="toast" :style="style">
    {{content}}
  </div>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      style: '',
      content: '',
      duration: 2000
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document.body.removeChild(this.$el)
      }, this.duration)
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/dialog/Toast.vue